"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function makeManyCodes(prefix, namePrefix, count, disableChat, informationId, restrictedStates) {
    const codes = {};
    const allowRestricted = {};
    if (restrictedStates && restrictedStates.length > 0) {
        for (const state of restrictedStates) {
            allowRestricted[state] = true;
        }
    }
    for (let i = 1; i <= count; i += 1) {
        codes[`${prefix}${i}`] = {
            hash: `macgf${i}${prefix}`,
            agency: true,
            informationId: informationId || `${prefix}${i}`,
            name: `${namePrefix} ${i}`,
            disableChat,
            allowRestricted
        };
    }
    return codes;
}
// NOTE: Do not put hyphens in descriptions (the second parameters to makeManyCodes)
// it messes with the (delicate) way that we pull the codes out in staff.
// underscores are intentional, do not remove!
exports.default = {
    ...makeManyCodes('AA', 'Agents Alliance', 8, true),
    ...makeManyCodes('AA0001_', 'All American Insurance Services', 5, true),
    ...makeManyCodes('ACR0001_', 'Acrisure, LLC dba Frates Irwin Risk Management Solutions', 2, true),
    ...makeManyCodes('AIA0001_', 'Alabama Insurance Agency, Inc.', 20, true),
    ...makeManyCodes('AIB0001_', 'Atlas Insurance Brokers, Inc.', 20, true),
    ...makeManyCodes('ADIG', 'Advisor Insurance Group', 1, true),
    ...makeManyCodes('AD0002_', 'Addison Insurance Group', 3, true),
    ...makeManyCodes('AGHRO', 'Agent Hero', 450, true),
    ...makeManyCodes('AHG0001_', 'Auto Home Group', 3, true),
    ...makeManyCodes('AIB0001_', 'Atlas Insurance Brokers', 50, true),
    ...makeManyCodes('AMS', 'AmSuisse', 33, true),
    ...makeManyCodes('AS0001_', 'American Safety Insurance', 2, true),
    ...makeManyCodes('BA0001_', 'Beasy Insurance Services', 4, true),
    ...makeManyCodes('BBC1_', 'Bill Beckman Company', 4, true),
    ...makeManyCodes('BE0001_', 'Better.com', 12, true),
    ...makeManyCodes('BCHMRK', 'Benchmark', 2, true),
    ...makeManyCodes('BJ0001_', 'B&J Insurance Agency, Inc.', 2, true),
    ...makeManyCodes('BR0001_', 'Brightway Insurance, LLC', 40, true),
    ...makeManyCodes('CA0001_', 'Careington Benefit Solutions', 4, true),
    ...makeManyCodes('CL0001_', 'Colling Insurance Services, Inc.', 4, true),
    ...makeManyCodes('CU0001_', 'Community Insurance Solutions', 4, true),
    ...makeManyCodes('CB0001_', 'Cobble Insurance Agency, Inc', 10, true),
    ...makeManyCodes('CJ0001_', 'CJ Insurance Group', 12, true),
    ...makeManyCodes('CK0001_', 'Corkren Insurance LLC', 4, true),
    ...makeManyCodes('CISS', 'Colorado Insurance', 100, true, 'CISS'),
    ...makeManyCodes('CLF0001_', 'Cliff Insurance Agency', 6, true),
    ...makeManyCodes('CLO', 'Clover Insurance Agency', 2, true),
    ...makeManyCodes('CP0001_', 'Chip Berry Insurance', 4, true),
    ...makeManyCodes('CY0001_', 'Coyle Insurance', 3, true),
    ...makeManyCodes('CM0001_', 'Comma Insurance', 39, true),
    ...makeManyCodes('DA0001_', 'Dorsey and Associates LLC', 4, true),
    ...makeManyCodes('DW0001_', 'Dan M Weier Agency', 3, true),
    ...makeManyCodes('DI0002_', 'Diamond Assurance Group', 5, true),
    ...makeManyCodes('FB0001_', 'Family Based Agency LLC', 3, true),
    ...makeManyCodes('FF0001_', 'Family First Insurance Alliance', 3, true),
    ...makeManyCodes('FI0001_', 'Faith Insurance Agency', 4, true),
    ...makeManyCodes('FOF0001_', '405 Insurance Advisors, LLC', 5, true),
    ...makeManyCodes('HA0002_', 'Handzel & Associates Ltd', 12, true),
    ...makeManyCodes('HO0001_', 'HomeFirst Agency, Inc.', 10, true),
    ...makeManyCodes('HRZ', 'HRZ', 50, true),
    ...makeManyCodes('IF1_', 'Integrity 1st, INC DBA Integrity First Insurance', 18, true),
    ...makeManyCodes('IHL0001_', 'IHLC Insurance Agency LLC/dba Univista Insurance', 5, true),
    ...makeManyCodes('IMB0001_', 'IMB, LLC', 35, true),
    ...makeManyCodes('IMSG', 'IMSG Insurance', 10, true),
    ...makeManyCodes('IN0001_', 'Insurance Professionals of Arizona', 40, true),
    ...makeManyCodes('INT', 'Integra Insurance Services', 32, true),
    ...makeManyCodes('IS0001_', 'Insurance Shoppe, LLC', 4, true),
    ...makeManyCodes('ISG1_', 'Insurance Solutions Group', 8, true),
    ...makeManyCodes('ISG', 'Insurance Solutions Group', 10, true),
    ...makeManyCodes('IP0001_', 'Insurance Plus LLC', 4, true),
    ...makeManyCodes('JCI0001_', 'J. Charles Insurance', 10, true),
    ...makeManyCodes('JC0001_', 'John R Carpenter Insurance Agency Inc', 10, true),
    ...makeManyCodes('JEN0001_', 'Jennings Insurance Solutions', 4, true),
    ...makeManyCodes('JL0001_', 'John Letson Insurance Agency Inc.', 2, true),
    ...makeManyCodes('JS0001_', 'Justice Couch Insurance', 4, true),
    ...makeManyCodes('KOVKG', 'Kover King', 1, true),
    ...makeManyCodes('KP0001_', 'Kris Posey Agency', 3, true),
    ...makeManyCodes('LE0001_', 'Legacy Insurance Enterprises', 8, true),
    ...makeManyCodes('LI0001_', 'Lighthouse Insurance Agency', 2, true),
    ...makeManyCodes('LW0001_', 'Loftis & Wetzel Corporation', 5, true),
    ...makeManyCodes('LW0002_', 'Loftis & Wetzel Corporation', 5, true),
    ...makeManyCodes('LW0003_', 'Loftis & Wetzel Corporation', 5, true),
    ...makeManyCodes('LW0004_', 'Loftis & Wetzel Corporation', 5, true),
    ...makeManyCodes('MA0001_', 'Midwest Agency', 10, true),
    ...makeManyCodes('MC0002_', 'McMillan Insurance Agency', 4, true),
    ...makeManyCodes('MY0001_', 'My Insurance Agent, Inc.', 8, true),
    ...makeManyCodes('OAC', 'Ohio Auto Club', 5, true),
    ...makeManyCodes('OZ0001_', 'Ozark Hills Insurance', 10, true),
    ...makeManyCodes('PF0001_', 'PFS Insurance Group, LLC Sterling', 5, true),
    ...makeManyCodes('PF0002_', 'PFS Insurance Group, LLC Yuma', 3, true),
    ...makeManyCodes('PP', 'Perfect Policy', 15, true),
    ...makeManyCodes('PR0001_', 'Provision Insurance Group, LLC.', 45, true, '', ['MI']),
    ...makeManyCodes('RC0001_', 'Rich & Cartmill, Inc', 40, true),
    ...makeManyCodes('RC0002_', 'Rich & Cartmill, Inc', 40, true),
    ...makeManyCodes('RCI0001_', 'Rocket City Insurance Group', 5, true),
    ...makeManyCodes('RI0001_', 'Riverton Insurance Agency', 4, true),
    ...makeManyCodes('RGTLP', 'Reliance Group Texas, L.P.', 5, true),
    ...makeManyCodes('RHK', 'Randy House and Associates', 3, true),
    ...makeManyCodes('SE0001_', 'Select Insurance Markets: One80', 44, true),
    ...makeManyCodes('SGIA', 'Southern Group Insurance Agency', 1, true),
    ...makeManyCodes('SK0001_', 'SteelKey Insurance', 14, true),
    ...makeManyCodes('SG0001_', 'Safeguard Insurance', 4, true),
    ...makeManyCodes('SMAZ', 'Smart Choice (AZ)', 25, true),
    ...makeManyCodes('SMCH', 'Smart Choice', 1, true),
    ...makeManyCodes('SMCO', 'Smart Choice (CO)', 14, true),
    ...makeManyCodes('SMIN', 'Smart Choice (IN)', 60, true),
    ...makeManyCodes('SMKS', 'Smart Choice (KS)', 30, true),
    ...makeManyCodes('SMMD', 'Smart Choice (MD)', 30, true),
    ...makeManyCodes('SMMI', 'Smart Choice (MI)', 2, true, '', ['MI']),
    ...makeManyCodes('SMMO', 'Smart Choice (MO)', 30, true),
    ...makeManyCodes('SMNE', 'Smart Choice (NE)', 30, true),
    ...makeManyCodes('SMOH', 'Smart Choice (OH)', 100, true),
    ...makeManyCodes('SMOK', 'Smart Choice (OK)', 5, true),
    ...makeManyCodes('SMPA', 'Smart Choice (PA)', 40, true),
    ...makeManyCodes('SMTN', 'Smart Choice (TN)', 40, true),
    ...makeManyCodes('SMTX', 'Smart Choice (TX)', 90, true),
    ...makeManyCodes('SMWI', 'Smart Choice (WI)', 40, true),
    ...makeManyCodes('SMWV', 'Smart Choice (WV)', 30, true),
    ...makeManyCodes('SN0001_', 'Sandstone Insurance Group', 2, true),
    ...makeManyCodes('SS0001_', 'S&S Insurance Group', 3, true),
    ...makeManyCodes('ST0001_', 'Strata Insurance Group, LLC', 7, true),
    ...makeManyCodes('TAC0001_', 'The Agency Collective', 100, true),
    ...makeManyCodes('TAG0001_', 'The Affinities Group, LLC', 20, true),
    ...makeManyCodes('TI0001_', 'The Insurance Alliance', 6, true),
    ...makeManyCodes('TIP0001_', 'The Insurance Professionals LLC', 2, true),
    ...makeManyCodes('TIS0001_', 'The Insurance Shop, LLC', 5, true),
    ...makeManyCodes('TIM0001_', 'The Insurance Man dba End Insurance Agency', 7, true),
    ...makeManyCodes('TWFG', 'TWFG Insurance Services, LLC', 200, true),
    ...makeManyCodes('QA', 'Quantum Assurance', 60, true),
    ...makeManyCodes('TOP', 'TOP Group', 11, true),
    ...makeManyCodes('VIF', 'Voldico Franchise', 50, true),
    ...makeManyCodes('VIN', 'Voldico Network', 50, true),
    ...makeManyCodes('WAY0001_', 'Way.com Insurance Agency', 119, true),
    ...makeManyCodes('WI0001_', 'Wise Men Insurance Services', 2, true)
};
//# sourceMappingURL=largeAgencyCodes.js.map